<h2 mat-dialog-title>Onset date</h2>

<mat-dialog-content class="date-dialog-content">
    <p class="code-line"><strong>{{ code }}</strong> {{ description }}</p>
    <p class="hint">
        When this condition was documented - not when it was captured. This is what appears
        on the record and on a claim.
    </p>

    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="picker" [(ngModel)]="selected" placeholder="YYYY-MM-DD">
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <p class="hint">
        Leave it empty if the onset is not known. An approximate date is worse than none.
    </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-button (click)="clear()">Clear date</button>
    <button mat-raised-button color="primary" (click)="save()">Save</button>
</mat-dialog-actions>
